const langAdminDocumentDownloadLogs = {
	title: {
		tag: 'admin.document_download_logs.title',
		fr: 'Téléchargement des appels de fonds',
		en: 'Capital calls download',
	},
	filter_download_state: {
		tag: 'admin.document_download_logs.filter_download_state',
		fr: 'Téléchargement',
		en: 'Download',
	},
	filter_keywords: {
		tag: 'admin.document_download_logs.filter_keywords',
		fr: 'Nom du document',
		en: 'Document name',
	},
	filter_funds: {
		tag: 'admin.document_download_logs.filter_funds',
		fr: 'Fonds',
		en: 'Funds',
	},
	filter_groups: {
		tag: 'admin.document_download_logs.filter_groups',
		fr: 'Groupes',
		en: 'Groups',
	},
	filter_start_released_date: {
		tag: 'admin.document_download_logs.filter_start_released_date',
		fr: 'Date de diffusion mini',
		en: 'Start release date',
	},
	filter_end_released_date: {
		tag: 'admin.document_download_logs.filter_end_released_date',
		fr: 'Date de diffusion maxi',
		en: 'End release date',
	},
};

export default langAdminDocumentDownloadLogs;
